/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NewReportIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <path d="M8.000,14.000 L2.000,14.000 C0.895,14.000 -0.000,13.104 -0.000,12.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 L5.000,-0.000 L10.000,5.000 L10.000,12.000 C10.000,13.104 9.105,14.000 8.000,14.000 ZM6.000,12.000 L7.000,12.000 L7.000,8.000 L6.000,8.000 L6.000,12.000 ZM3.000,6.000 L2.000,6.000 L2.000,12.000 L3.000,12.000 L3.000,6.000 ZM4.000,9.000 L4.000,12.000 L5.000,12.000 L5.000,9.000 L4.000,9.000 ZM5.000,1.000 L5.000,5.000 L9.000,5.000 L5.000,1.000 Z"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}